// FieldHint + ValidationMessage (Spec §9) — the two inline form primitives.
// FieldHint is short helper text/examples under a field; ValidationMessage is a
// helpful "what is wrong and how to fix it" error (never a silent failure).

import type { ReactNode } from 'react'
import { Info, AlertCircle } from 'lucide-react'

export function FieldHint({ children, id }: { children: ReactNode; id?: string }) {
  return (
    <p id={id} className="mt-1 flex items-start gap-1.5 text-xs text-slate-500">
      <Info size={13} className="mt-0.5 shrink-0 text-slate-400" aria-hidden />
      <span>{children}</span>
    </p>
  )
}

export function ValidationMessage({
  children,
  id,
  tone = 'error',
}: {
  children: ReactNode
  id?: string
  tone?: 'error' | 'success'
}) {
  const color = tone === 'success' ? 'text-emerald-600' : 'text-rose-600'
  return (
    <p id={id} role={tone === 'error' ? 'alert' : undefined} className={`mt-1 flex items-start gap-1.5 text-xs ${color}`}>
      <AlertCircle size={13} className="mt-0.5 shrink-0" aria-hidden />
      <span>{children}</span>
    </p>
  )
}

export default FieldHint
